import FuseScrollbars from '../../../../@fuse/core/FuseScrollbars';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import withReducer from '../../../../app/store/withReducer';
import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { selectQuickPanelData } from './store/dataSlice';
import reducer from './store';
import { selectQuickPanelState, toggleQuickPanel } from './store/stateSlice';

const StyledSwipeableDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: 280,
  },
}));

function QuickPanel(props) {
  const dispatch = useDispatch();

  const data = useSelector(selectQuickPanelData);
  const state = useSelector(selectQuickPanelState);

  const [checked, setChecked] = useState('notifications');

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  return (
    <StyledSwipeableDrawer
      open={state}
      anchor="right"
      onOpen={(ev) => {}}
      onClose={(ev) => dispatch(toggleQuickPanel())}
      disableSwipeToOpen
    >
      <FuseScrollbars>
        <ListSubheader component="div">Filtros</ListSubheader>
        <ListItem>
          <ListItemText primary="Update now" />
        </ListItem>
        <div className="mb-0 py-16 px-24">
          <div className="relative w-full lg:max-w-sm">
            <select className="w-full p-2.5 text-gray-500 bg-white border rounded-md shadow-sm outline-none appearance-none focus:border-indigo-600">
              <option>Real time</option>
              <option>time-stamp</option>
              <option>moment</option>
              <option>date</option>
            </select>
          </div>
        </div>
        <Divider />
        <List>
          <ListSubheader component="div">Region</ListSubheader>
          <FormGroup className="p-12">
            <FormControlLabel control={<Checkbox defaultChecked />} label="Norte" />
            <FormControlLabel control={<Checkbox />} label="Sur" />
            <FormControlLabel control={<Checkbox defaultChecked />} label="Centro" />
            <FormControlLabel control={<Checkbox />} label="Oriente" />
            <FormControlLabel control={<Checkbox defaultChecked />} label="Poniente" />
          </FormGroup>
        </List>
        <Divider />
        <List>
          <List>
            <ListSubheader component="div">Grupo</ListSubheader>
            <FormGroup className="p-12">
              <FormControlLabel control={<Checkbox defaultChecked />} label="Centro de datos" />
              <FormControlLabel control={<Checkbox />} label="Regional" />
              <FormControlLabel control={<Checkbox defaultChecked />} label="Alto" />
              <FormControlLabel control={<Checkbox />} label="Intensivo" />
              <FormControlLabel control={<Checkbox defaultChecked />} label="Medio" />
              <FormControlLabel control={<Checkbox defaultChecked />} label="Medio 2" />
              <FormControlLabel control={<Checkbox />} label="Basico" />
              <FormControlLabel control={<Checkbox defaultChecked />} label="Basico 2" />
              <FormControlLabel control={<Checkbox />} label="Bajo" />
            </FormGroup>
          </List>
        </List>
        <Divider />
        <List>
          <ListSubheader component="div">Inmueble</ListSubheader>
          <div className="mb-0 py-16 px-24">
            <div className="relative w-full lg:max-w-sm">
              <select className="w-full p-2.5 text-gray-500 bg-white border rounded-md shadow-sm outline-none appearance-none focus:border-indigo-600">
                <option>Inmueble</option>
                <option>time-stamp</option>
                <option>moment</option>
                <option>date</option>
              </select>
            </div>
          </div>
        </List>
      </FuseScrollbars>
    </StyledSwipeableDrawer>
  );
}

export default withReducer('quickPanel', reducer)(memo(QuickPanel));
